<template>
  <div>
    <div id="primary" class="content-area">
      <section class="detail pt-50 pb-20">
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <div class="detail__title">
                <h2>{{ detail.TenKeHoach }}</h2>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <div class="detail-tab">
                <!--Nav Button  -->
                <nav>
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a
                      class="nav-item nav-link"
                      v-bind:class="{ 'active show': tab == 1 }"
                      id="nav-1-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="nav-1"
                      aria-selected="true"
                      v-on:click="tab = 1"
                      >Thông tin phiên đấu giá</a
                    >
                    <a
                      class="nav-item nav-link"
                      v-bind:class="{ 'active show': tab == 2 }"
                      id="nav-2-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="nav-2"
                      aria-selected="false"
                      v-on:click="tab = 2"
                      >Chi tiết tài sản</a
                    >
                  </div>
                </nav>
                <!--End Nav Button  -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="tab-content" id="nav-tabContent">
                <!-- card one -->
                <div
                  v-if="tab == 1"
                  class="tab-pane fade"
                  v-bind:class="{ 'active show': tab == 1 }"
                  id="nav-1"
                  role="tabpanel"
                  aria-labelledby="nav-1-tab"
                >
                  <div class="row">
                    <!--Image Detail-->
                    <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                      <div class="detail__img">
                        <carousel
                          :paginationPosition="'bottom-overlay'"
                          :per-page="1"
                          :autoplay="true"
                          :loop="true"
                          :autoplayTimeout="3000"
                          v-if="detail.TaiSanDauGia && detail.TaiSanDauGia.length > 0"
                        >
                          <slide
                            data-index="0"
                            v-for="i in detail.TaiSanDauGia[0].DinhKem"
                            :key="i"
                            style="width: 100%; height: 350px;"
                          >
                            <img
                              alt=""
                              v-gallery:groupName
                              style="cursor: zoom-in;border-radius: 3px;object-fit: contain;width: 100%;min-height: 100%;"
                              :src="i.LinkDownload"
                            />
                          </slide>
                        </carousel>
                      </div>
                    </div>
                    <!--End Detail-->
                    <!--Info Detail-->
                    <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12">
                      <div class="detail__info">
                        <span>{{ detail.MoTaTomTat }}</span>
                      </div>
                      <div class="detail__row" v-if="detail.DauGiaVien && detail.DauGiaVien.HoTen">
                        <span class="detail__label txt-main">Đấu giá viên:</span>
                        <span class="detail__value" style="text-decoration: underline;"
                          ><a v-on:click="$modal.show('modal-auctioneer')">{{ detail.DauGiaVien.HoTen }}</a></span
                        >
                      </div>
                      <div class="detail__row">
                        <span class="detail__label txt-main">Người có tài sản:</span>
                        <span class="detail__value">{{ detail.NguoiBanDauGia }}</span>
                      </div>
                      <div class="detail__row">
                        <span class="detail__label txt-main">Ngày công bố:</span>
                        <span class="detail__value">{{ detail.NgayCongBo | formatDateNgay }}</span>
                      </div>
                      <div class="detail__row">
                        <span class="detail__label txt-main">Thời điểm bắt đầu phiên đấu giá:</span>
                        <span class="detail__value">{{ detail.BatDau | formatDate }}</span>
                      </div>
                      <div class="detail__row">
                        <span class="detail__label txt-main">Thời điểm kết thúc phiên đấu giá:</span>
                        <span class="detail__value">
                          {{
                            (detail.ThoiGianXacNhanTrungGia ? detail.ThoiGianXacNhanTrungGia : detail.KetThucDuKien)
                              | formatDate
                          }}
                        </span>
                      </div>
                      <div class="detail__row">
                        <span class="detail__label txt-main">Giá khởi điểm:</span>
                        <span class="detail__value">{{ detail.GiaKhoiDiem | formatPrice }} {{ detail.DonViTinh }}</span>
                      </div>
                      <div class="detail__row">
                        <span class="detail__label txt-main">Bước giá:</span>
                        <span class="detail__value">{{ detail.BuocGia | formatPrice }} {{ detail.DonViTinh }}</span>
                      </div>
                      <div class="detail__row">
                        <span class="detail__label  txt-main">Chi phí tham gia đấu giá:</span>
                        <span class="detail__value">
                          {{ detail.PhiThamGiaDauGia | formatPrice }} {{ detail.DonViTinh }}
                        </span>
                      </div>
                      <div class="detail__row">
                        <span class="detail__label  txt-main">Tiền đặt trước:</span>
                        <span class="detail__value">
                          {{ detail.SoTienDatCoc | formatPrice }} {{ detail.DonViTinh }}
                        </span>
                      </div>
                      <div v-if="isAuctionEnded">
                        <!-- <div class="detail__row">
                          <span class="detail__label txt-main primary-color">Họ tên người trúng đấu giá:</span>
                          <span class="detail__value">
                            {{ detail.HoTenNguoiTrungGia }}
                          </span>
                        </div> -->
                        <div class="detail__row">
                          <span class="detail__label txt-main primary-color">Mã khách hàng trúng đấu giá:</span>
                          <span class="detail__value">
                            {{ detail.MaNguoiTrungGia }}
                          </span>
                        </div>
                        <div class="detail__row">
                          <span class="detail__label txt-main primary-color">Giá trúng đấu giá:</span>
                          <span class="detail__value">
                            {{ detail.GiaTrungDauGia | formatPrice }} {{ detail.DonViTinh }}
                          </span>
                        </div>
                        <div class="detail__row">
                          <span class="detail__label txt-main primary-color">Thời điểm xác nhận kết quả đấu giá:</span>
                          <span class="detail__value">
                            {{ detail.ThoiGianXacNhanTrungGia | formatDate }}
                          </span>
                        </div>
                      </div>
                      <div v-else-if="!isAuctionStarted && !isBiddingEnded" class="detail__row">
                        <button style="background-color: rgb(0, 98, 246)" class="detail__btn">
                          Phiên đấu giá sắp diễn ra
                        </button>
                      </div>
                      <div class="detail__row" v-if="isAuctionEnded">
                        <button style="background-color: red;" class="detail__btn">
                          Đã Kết Thúc
                        </button>
                      </div>
                      <div
                        class="detail__row"
                        v-if="isRegister && isInitHistoryDone && !isBiddingEnded && isAuctionStarted"
                      >
                        <button
                          style="width: unset; background-color: rgb(0, 98, 246);padding-left: 10px;padding-right: 10px;"
                          class="detail__btn"
                        >
                          Giá cao nhất hiện tại:
                          {{ topPrice | formatPrice }}
                          {{ detail.DonViTinh }}
                        </button>
                      </div>

                      <div v-if="!isRegister && !isBiddingEnded && isAuctionStarted" class="detail__row">
                        <button style="background-color: #ffc107;" class="detail__btn">
                          Phiên đấu giá đang diễn ra
                        </button>
                      </div>
                    </div>
                  </div>
                  <!--End Info Detail-->
                </div>
                <!-- end card one -->
                <!-- card two -->
                <div
                  v-else-if="tab == 2"
                  class="tab-pane fade"
                  v-bind:class="{ 'active show': tab == 2 }"
                  id="nav-2"
                  role="tabpanel"
                  aria-labelledby="nav-2-tab"
                >
                  <div class="row">
                    <!--Image Detail-->
                    <div class="col-xl-12">
                      <div class="detail__des" v-html="detail.TaiSanDauGia[0].MoTaChiTiet"></div>
                    </div>
                    <!--End Detail-->
                  </div>
                </div>
                <!-- end card two -->
              </div>
            </div>
          </div>
          <template v-if="!isInitHistoryDone && isAuctionStarted && !isAuctionEnded">
            <app-loading :loading="true" />
          </template>
          <template v-if="isInitHistoryDone && isRegister && isAuctionStarted && !isAuctionEnded">
            <div class="row mb-20" v-show="tab == 1">
              <div class="col-lg-5 col-md-5 col-sm-12">
                <div
                  style="text-align: center;"
                  class="main-auction auction-time-countdown hasCountdown"
                  data-time="1589500800"
                  data-auctionid="4452"
                  data-format="yowdHMS"
                >
                  <countdown
                    v-if="!isBiddingEnded && renderComponent && currentTime != ''"
                    :time="endTime - dateCountDown < 0 ? 0 : endTime - dateCountDown"
                  >
                    <template slot-scope="props">
                      <span class="countdown_row countdown_show5">
                        <span class="countdown_section">
                          <span class="countdown_amount" v-if="props.days < 10">0{{ props.days }}</span>
                          <span class="countdown_amount" v-else>{{ props.days }}</span>
                          <br />Ngày
                        </span>
                        <span class="countdown_section">
                          <span class="countdown_amount" v-if="props.hours < 10">0{{ props.hours }}</span>
                          <span class="countdown_amount" v-else>{{ props.hours }}</span>
                          <br />Giờ
                        </span>
                        <span class="countdown_section">
                          <span class="countdown_amount" v-if="props.minutes < 10">0{{ props.minutes }}</span>
                          <span class="countdown_amount" v-else>{{ props.minutes }}</span>
                          <br />Phút
                        </span>
                        <span class="countdown_section">
                          <span class="countdown_amount" v-if="props.seconds < 10">0{{ props.seconds }}</span>
                          <span class="countdown_amount" v-else>{{ props.seconds }}</span>
                          <br />Giây
                        </span>
                      </span>
                    </template>
                  </countdown>
                  <countdown
                    v-else-if="endTimeAccept && renderComponent"
                    :time="endTime - dateCountDown < 0 ? 0 : endTime - dateCountDown"
                  >
                    <template slot-scope="props">
                      <span class="countdown_row countdown_show5" style="color: red;">
                        <span class="countdown_section">
                          <span class="countdown_amount" v-if="props.days < 10">0{{ props.days }}</span>
                          <span class="countdown_amount" v-else>{{ props.days }}</span>
                          Ngày
                        </span>
                        <span class="countdown_section">
                          <span class="countdown_amount" v-if="props.hours < 10">0{{ props.hours }}</span>
                          <span class="countdown_amount" v-else>{{ props.hours }}</span>
                          Giờ
                        </span>
                        <span class="countdown_section">
                          <span class="countdown_amount" v-if="props.minutes < 10">0{{ props.minutes }}</span>
                          <span class="countdown_amount" v-else>{{ props.minutes }}</span>
                          Phút
                        </span>
                        <span class="countdown_section">
                          <span class="countdown_amount" v-if="props.seconds < 10">0{{ props.seconds }}</span>
                          <span class="countdown_amount" v-else>{{ props.seconds }}</span>
                          Giây
                        </span>
                      </span>
                    </template>
                  </countdown>
                </div>
              </div>
              <template v-if="isBiddingEnded && topId == currentUser.id">
                <div class="col-lg-3 col-md-3 col-sm-3">
                  <button
                    v-on:click="acceptResult()"
                    class="detail__btn"
                    style="background: #6571ff;height: 60px;width:100%"
                  >
                    Đồng ý kết quả đấu giá
                  </button>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                  <button
                    v-on:click="removeResult()"
                    class="detail__btn"
                    style="background: red;height: 60px;width:100%"
                  >
                    Từ chối kết quả đấu giá
                  </button>
                </div>
              </template>
              <div class="col-lg-6 col-md-6 col-sm-12" v-if="!isBiddingEnded && !isWithdraw">
                <div class="detail__row" style="border-bottom: unset;">
                  <div class="rice-gr">
                    <div v-on:click="addPrice(-detail.BuocGia)" class="icon-sub">
                      <i class="fas fa-minus"></i>
                    </div>
                    <money class="detail__input" v-model="price" v-bind="money"></money>
                    <div v-on:click="addPrice(+detail.BuocGia)" class="icon-sub">
                      <i class="fas fa-plus"></i>
                    </div>
                  </div>
                  <button style="width: 100px;" :disabled="isEnd" v-on:click="play()" class="detail__btn">
                    Trả giá
                  </button>
                  <p class="txt-rice" style="text-transform: capitalize;">
                    {{ priceString }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row" v-show="tab == 1">
              <div class="table-responsive col-lg-12 col-md-12 col-sm-12">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Người đấu giá</th>
                      <th>Giá trả({{ detail.DonViTinh }})</th>
                      <th>Thời điểm trả giá</th>
                      <th>Ghi chú</th>
                      <th v-if="detail.ChoPhepRutGia"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="i in auctionHistory"
                      :key="i.Id"
                      :class="[{ 'row-active': i.TrangThai === statusAuction.win, 'is-noop': i.TrangThaiId != 1 }]"
                    >
                      <td class="date">
                        {{ i.SoDangKy }}
                        <template v-if="i.TaiKhoanDauGia.Id == currentUser.id">
                          ({{ i.TaiKhoanDauGia.TaiKhoan }})
                        </template>
                      </td>
                      <td class="bid">
                        <span class="woocommerce-Price-amount amount">{{ i.GiaTra | formatPrice }}</span>
                      </td>
                      <td class="username">
                        {{ i.ThoiDiemTraGia | formatDate }}
                      </td>
                      <td class="note">
                        {{ i.TrangThai }}
                      </td>
                      <td v-if="detail.ChoPhepRutGia" class="proxy" style="text-align: center;">
                        <a
                          style="padding: 5px;border: 1px solid #ccc;"
                          v-on:click="removePrice()"
                          v-if="
                            !isBiddingEnded &&
                              allowRemovePrice &&
                              topId == currentUser.id &&
                              topPrice == i.GiaTra &&
                              i.TrangThaiId == AuctionHistoryStatus.VALID
                          "
                        >
                          Rút Giá
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </div>
      </section>
      <modal :adaptive="true" :resizable="true" name="modal-auctioneer" height="auto">
        <div class="yith-wcqv-wrapper">
          <div class="yith-wcqv-main">
            <div id="yith-quick-view-content" class="woocommerce single-product">
              <div class="product">
                <div class="">
                  <a v-on:click="$modal.hide('modal-auctioneer')" style="float: right;">❌</a>
                  <div class="row" style="padding: 15px;" v-if="detail.DauGiaVien">
                    <div class="col-md-4 col-lg-4 col-sm-12">
                      <div
                        class="woocommerce-product-gallery woocommerce-product-gallery--with-images woocommerce-product-gallery--columns-4 images"
                        style="opacity: 1; transition: opacity 0.25s ease-in-out 0s;"
                      >
                        <img
                          v-if="detail.DauGiaVien.DinhKem.length > 0"
                          alt=""
                          style="width: 100%;"
                          :src="detail.DauGiaVien.DinhKem[0].LinkDownload"
                        />
                      </div>
                    </div>
                    <div class="col-md-8 col-lg-8 col-sm-12">
                      <div>
                        <div class="row">
                          <div class="col-md-12">
                            <h3>{ detail.DauGiaVien.HoTen }}</h3>
                          </div>
                          <div class="col-8">
                            <span>Chứng chỉ hành nghề đấu giá số:</span>
                          </div>
                          <div class="col-4">
                            <span>
                              <strong>{{ detail.DauGiaVien.SoCCHN }}</strong>
                            </span>
                          </div>
                          <div class="col-8">
                            <span>Ngày cấp chứng chỉ hành nghề:</span>
                          </div>
                          <div class="col-4">
                            <span>
                              <strong>{{ detail.DauGiaVien.NgayCapCCHN | formatDateNotTime }} </strong>
                            </span>
                          </div>
                          <div class="col-8">
                            <span>Số thẻ đấu giá viên:</span>
                          </div>
                          <div class="col-4">
                            <span>
                              <strong>{{ detail.DauGiaVien.SoTheDauGiaVien }}</strong>
                            </span>
                          </div>
                          <div class="col-8">
                            <span>Ngày cấp thẻ đấu giá viên:</span>
                          </div>
                          <div class="col-4">
                            <span
                              ><strong>{{ detail.DauGiaVien.NgayCapTheDauGia | formatDateNotTime }}</strong>
                            </span>
                          </div>
                          <div class="col-8">
                            <span>Nơi cấp thẻ đấu giá:</span>
                          </div>
                          <div class="col-4">
                            <span>
                              <strong>{{ detail.DauGiaVien.NoiCapTheDauGia }}</strong>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { Money } from 'v-money';
import Vue from 'vue';
import VueCountdown from '@chenfengyuan/vue-countdown';
import { Carousel, Slide } from 'vue-carousel';

import AppLoading from '@/components/AppLoading.vue';

import Auction from '@/common/api/auction';
import mixin from '@/mixins/mixin.js';
import { AuctionHistoryStatus, AuctionStatus, RegisterActionStatus } from '@/constants';

import 'sweetalert2/dist/sweetalert2.min.css';

Vue.component(VueCountdown.name, VueCountdown);
const mangso = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];

const statusAuction = {
  win: 'Xác nhận trúng giá'
};

export default {
  components: { Money, Carousel, Slide, AppLoading },
  name: 'ProductAuction',
  props: ['id'],
  mixins: [mixin],
  data() {
    return {
      idVictim: 0,
      nextPerson: 0,
      endTimeAccept: false,
      dateCountDown: 0,
      wait: false,
      topId: -1,
      topName: '',
      topTime: '',
      topPrice: 0,
      // Giá trả cao nhất hiện tại của mình
      topCurrentPrice: 0,
      isEnd: false,
      allowRemovePrice: false,
      renderComponent: true,
      isRegister: false,
      auctionHistory: [],
      endTime: '',
      detail: {
        TenKeHoach: '',
        GiaKhoiDiem: 0,
        BuocGia: 0,
        PhiThamGiaDauGia: 0,
        SoTienDatCoc: 0
      },
      isShowAlert: false,
      tab: 1,
      price: 0,
      money: {
        decimal: '',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      isShowAlertEnd: false,
      typeNoti: 0,
      interval: null,
      statusAuction,
      isBiddingEnded: false,
      isAuctionEnded: false,
      isAuctionStarted: false,
      // Xem mình có rút giá không
      isWithdraw: false,
      AuctionHistoryStatus,
      // Đã confirm trúng giá hay chưa
      isConfirmedBid: false,
      isInitHistoryDone: false
    };
  },
  beforeDestroy: function() {
    this.clearCallHistory();
  },
  filters: {
    formatDate: function(value) {
      if (!value) return '';
      return moment(String(value)).format('HH:mm:ss DD/MM/YYYY');
    },
    formatDateNgay: function(value) {
      if (!value) return '';
      return moment(String(value)).format('DD/MM/YYYY');
    },
    formatDateNotTime: function(value) {
      if (!value) return '';
      return moment(String(value)).format('DD/MM/YYYY');
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'isAuthenticated', 'currentTime']),
    priceString: function() {
      if (this.price <= 0) {
        return '';
      }
      return this.docso(this.price);
    }
  },
  watch: {},
  async created() {
    this.checkRegister();
    await this.getDetailAuction();
    this.checkAuctionStatus();
  },
  mounted() {},
  methods: {
    showAuctioneer() {
      this.$modal.show('modal-auctioneer');
    },
    removeResult() {
      if (this.typeNoti === 0) {
        this.$swal
          .fire({
            title: 'Quý khách hàng có chắc chắn từ chối kết quả đấu giá không?',
            text: 'Sau khi từ chối, quý khách sẽ không được hoàn trả lại tiền đặt trước',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Đồng ý',
            cancelButtonText: 'Hủy'
          })
          .then((result) => {
            if (result.value) {
              Auction.removeResult(this.id, this.currentUser.id).then(({ data }) => {
                if (data.Status !== 200) {
                  this.$swal.fire({
                    title: 'Lỗi!',
                    text: data.Message,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Đồng ý'
                  });
                } else {
                  this.$swal.fire({
                    title: 'Thành công!',
                    text: 'Quý khách đã từ chối quyền trúng đấu giá.',
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonText: 'Đồng ý'
                  });
                  this.isAuctionEnded = true;
                }
              });
            }
          });
      } else if (this.typeNoti === 1) {
        Auction.removeResult(this.id, this.currentUser.id).then(({ data }) => {
          this.$swal.fire({
            title: 'Phiên đấu giá đã kết thúc',
            text: '',
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Đồng ý'
          });
        });
      }
    },
    acceptResult() {
      this.$swal
        .fire({
          title: 'Quý khách hàng chắc chắn đồng ý kết quả đấu giá?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy'
        })
        .then((data) => {
          if (data.value) {
            Auction.acceptResult(this.id, this.currentUser.id).then(({ data }) => {
              if (data.Status !== 200) {
                this.$swal.fire({
                  title: 'Lỗi!',
                  text: data.Message,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonText: 'Đồng ý'
                });
              } else {
                this.$swal.fire({
                  title:
                    'Chúc mừng quý khách đã là người trả giá cao nhất. Thông báo kết quả cụ thể sẽ được gửi vào email của Quý khách.',
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonText: 'Đồng ý'
                });
                this.isAuctionEnded = true;
                this.getDetailAuction();
              }
            });
          }
        });
    },
    removePrice() {
      this.$swal
        .fire({
          title: 'Quý khách có chắc chắn rút lại giá đã trả không?',
          text: 'Người rút lại giá đã trả bị truất quyền tham gia đấu giá và không được hoàn trả lại tiền đặt trước.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Có',
          cancelButtonText: 'Không'
        })
        .then((result) => {
          if (result.value) {
            Auction.removePrice(this.id, this.currentUser.id).then(({ data }) => {
              if (data.Message && data.Message !== '') {
                this.$swal.fire({
                  title: 'Lỗi',
                  text: data.Message,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Đồng ý'
                });
              } else {
                this.$swal.fire({
                  title: 'Quý khách đã rút lại giá đã trả thành công',
                  text: 'Quý khách không được tham gia đấu giá tiếp',
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Đồng ý'
                });
                this.isWithdraw = true;
              }
            });
          }
        });
    },
    play() {
      if (this.price - this.detail.GiaKhoiDiem < 0) {
        this.$swal.fire({
          title: 'Lỗi...',
          text: 'Giá trả không hợp lệ, Khách hàng không trả giá thấp hơn giá khởi điểm',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Đồng ý'
        });
        return;
      }
      if (this.price <= this.topPrice) {
        this.$swal.fire({
          title: 'Lỗi...',
          text: 'Giá trả không hợp lệ, Khách hàng không trả giá thấp hơn giá cao nhất được hệ thống ghi nhận',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Đồng ý'
        });
        return;
      }
      if ((this.price - this.detail.GiaKhoiDiem) % this.detail.BuocGia !== 0) {
        this.$swal.fire({
          title: 'Lỗi...',
          text: 'Giá trả không hợp lệ, giá hợp lệ = giá khởi điểm + nguyên lần bước giá',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Đồng ý'
        });
        return;
      }
      this.$swal
        .fire({
          title:
            'Quý khách chắc chắn trả giá là: ' +
            this.$options.filters.formatPrice(this.price) +
            ' (' +
            this.docso(this.price) +
            ' )?',
          text: '',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Có',
          cancelButtonText: 'Không'
        })
        .then((result) => {
          if (result.value) {
            Auction.play(this.id, this.currentUser.id, this.price).then(({ data }) => {
              let err = data.Message;
              if (data.Message.includes(' at')) {
                err = 'Lỗi không xác định';
              }

              if (err !== '') {
                this.$swal.fire({
                  title: 'Lỗi...',
                  text: err,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonText: 'Đồng ý'
                });
              }
            });
          }
        });
    },
    clearCallHistory() {
      clearInterval(this.interval);
    },
    checkRegister() {
      if (this.isAuthenticated) {
        Auction.checkRegister(this.currentUser.id, this.id).then(({ data }) => {
          if (data.Data === RegisterActionStatus.REGISTERED_APPROVED) {
            this.isRegister = true;
            this.updateCountDown();
            // this.getHistory();
          }
        });
      }
    },
    addPrice(price) {
      this.price = this.price + price;
    },
    showCountDownRemoveResult(HanTuTroiTrungDauGia) {
      this.endTimeAccept = true;
      this.endTime = HanTuTroiTrungDauGia;
      this.dateCountDown = this.currentTime;
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    updateCountDown() {
      setInterval(() => {
        if (!this.isBiddingEnded) {
          this.dateCountDown = this.currentTime;
          this.renderComponent = false;
          this.$nextTick(() => {
            this.renderComponent = true;
          });
        }
      }, 10000);
    },
    getHistory() {
      this.clearCallHistory();
      this.interval = setInterval(() => {
        if (this.nextPerson === this.currentUser.id || this.isAuctionStarted) {
          Auction.getHistory(this.id).then(({ data }) => {
            let HanTuTroiTrungDauGia = moment(data.Data.HanTuTroiTrungDauGia).valueOf();
            if (!this.isInitHistoryDone) {
              setTimeout(() => {
                this.isInitHistoryDone = true;
              }, 200);
            }

            this.isAuctionEnded = this.currentTime > HanTuTroiTrungDauGia;
            if (this.isAuctionEnded) {
              this.clearCallHistory();
              return;
            }
            // trường hợp phiên đấu giá ko thành thì thời gian kết thúc mới sẽ nhỏ hơn thời gian kết thúc cũ
            if (moment(this.detail.KetThuc).valueOf() > moment(data.Data.EndDate).valueOf()) {
              this.clearCallHistory();
              this.nextPerson = -1;
              this.$swal.fire({
                title: 'Phiên đấu giá kết thúc!',
                text: 'Quý khách vui lòng vào phần kết quả đấu giá để xem thông tin!',
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'Đồng ý'
              });
              this.clearCallHistory();
              return;
            }
            this.auctionHistory = data.Data.ListData || [];

            // Check xem mình có rút giá không
            for (const item of this.auctionHistory) {
              if (
                item.TrangThaiId === AuctionHistoryStatus.WITHDRAW &&
                item.TaiKhoanDauGia &&
                item.TaiKhoanDauGia.Id === this.currentUser.id
              ) {
                this.isWithdraw = true;
                break;
              }
            }

            this.allowRemovePrice = false;
            let priceReject = 0;
            let showAlert = false;
            // lay gia cao nhat cua user dang dang nhap
            for (const element of this.auctionHistory) {
              if (element.TaiKhoanDauGia.Id === this.currentUser.id && element.GiaTra >= this.topCurrentPrice) {
                this.topCurrentPrice = element.GiaTra;
                break;
              }
            }
            for (let i = 0; i < this.auctionHistory.length; i++) {
              // Từ chối trúng giá
              if (this.auctionHistory[i].TrangThaiId === AuctionHistoryStatus.REJECTED && priceReject === 0) {
                priceReject = this.auctionHistory[i].GiaTra;
              }

              // Nếu người cao nhất từ chối trúng giá và người tiếp theo là mình + chưa hết hạn đồng ý trúng giá và giá cao nhất + số tiền đặt cọc >= giá từ chối
              if (
                priceReject !== 0 &&
                this.nextPerson === this.currentUser.id &&
                HanTuTroiTrungDauGia > this.currentTime &&
                this.topCurrentPrice + this.detail.SoTienDatCoc >= priceReject
              ) {
                this.nextPerson = -1;
                if (!showAlert && !this.isAuctionEnded) {
                  showAlert = true;
                  this.topId = this.currentUser.id;
                  this.$swal.fire({
                    title: 'Người trả giá cao nhất đã từ chối kết quả trúng đấu giá',
                    text:
                      'Quý khách có chấp nhận mua tài sản đấu giá với mức giá trả là ' +
                      this.$options.filters.formatPrice(this.topCurrentPrice) +
                      this.detail.DonViTinh +
                      '  không? Quý khách có 15 phút để xác nhận.',
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonText: 'Đã hiểu'
                  });
                  this.typeNoti = 1;
                  this.showCountDownRemoveResult(HanTuTroiTrungDauGia);
                }
                break;
              }
              // Nếu giá trả hợp lệ
              if (this.auctionHistory[i].TrangThaiId === AuctionHistoryStatus.VALID) {
                this.topName = this.auctionHistory[i].TaiKhoanDauGia.HoTen;
                this.topPrice = this.auctionHistory[i].GiaTra;
                this.topTime = this.auctionHistory[i].ThoiDiemTraGia;
                this.topId = this.auctionHistory[i].TaiKhoanDauGia.Id;
                // Chỉ cho phép rút giá nếu người trả giá cao nhất là người đăng nhập và giá trả cao nhất
                if (i === 0) {
                  this.allowRemovePrice = true;
                }
                // Nếu mà còn giá trả phía sau i
                if (i + 1 < this.auctionHistory.length) {
                  for (var j = i + 1; j < this.auctionHistory.length; j++) {
                    // Nếu giá trả tiếp theo hợp lệ
                    if (this.auctionHistory[j].TrangThaiId === AuctionHistoryStatus.VALID) {
                      // 2 người trả giá khác nhau
                      if (this.auctionHistory[j].TaiKhoanDauGia.Id !== this.auctionHistory[i].TaiKhoanDauGia.Id) {
                        this.nextPerson = this.auctionHistory[j].TaiKhoanDauGia.Id;
                      } else {
                        this.nextPerson = -1;
                      }
                      break;
                    }
                  }
                }
                break;
              }
            }

            if (this.currentTime >= moment(data.Data.EndDate).valueOf()) {
              this.isBiddingEnded = true;
              if (this.topId === this.currentUser.id) {
                this.clearCallHistory();
                if (!showAlert && !this.isAuctionEnded) {
                  showAlert = true;
                  this.showCountDownRemoveResult(HanTuTroiTrungDauGia);
                }
              } else if (!this.isShowAlertEnd) {
                this.isShowAlertEnd = true;
                if (
                  this.nextPerson === this.currentUser.id &&
                  this.topCurrentPrice + this.detail.SoTienDatCoc >= this.topPrice &&
                  !this.isAuctionEnded &&
                  priceReject === 0
                ) {
                  this.$swal.fire({
                    title: 'Đừng rời khỏi phòng!',
                    text:
                      'Quý khách là người trả giá cao liền kề với giá trả cao nhất hệ thống ghi nhận! Trong thời gian 15 phút kể từ thời điểm kết thúc trả giá nếu người trả giá cao nhất từ chối trúng giá. Quý khách sẽ được quyền chấp nhận trúng giá hay không',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'Đồng ý'
                  });
                  this.showCountDownRemoveResult(HanTuTroiTrungDauGia);
                } else {
                  this.$swal.fire({
                    title: 'Phiên đấu giá kết thúc!',
                    text: 'Quý khách vui lòng vào phần kết quả đấu giá để xem thông tin!',
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonText: 'Đồng ý'
                  });
                  this.clearCallHistory();
                }
              }
            } else if (data.Data.EndDate !== this.detail.KetThuc) {
              this.detail.KetThuc = data.Data.EndDate;
              this.endTime = moment(this.detail.KetThuc).valueOf();
              this.dateCountDown = this.currentTime;
              this.renderComponent = false;
              this.$nextTick(() => {
                this.renderComponent = true;
              });
            }

            if (this.isAuctionEnded) {
              this.clearCallHistory();
            }
          });
        }
      }, 3000);
    },
    checkAuctionStatus() {
      this.price = this.detail.GiaKhoiDiem;
      this.dateCountDown = this.currentTime;

      this.endTime = moment(this.detail.KetThuc).valueOf();
      var startTime = moment(this.detail.BatDau).valueOf();
      this.idVictim = this.detail.IdNguoiTrungGia;
      this.isAuctionStarted = this.currentTime >= startTime;
      this.isAuctionEnded = !!this.detail.ThoiGianXacNhanTrungGia;
      if (this.detail.TrangThai.Id === AuctionStatus.PENDING_APPROVAL) {
        this.detail = null;
        this.isBiddingEnded = true;
      } else if (this.currentTime >= this.endTime) {
        this.isBiddingEnded = true;
      } else if (this.currentTime < startTime) {
        setTimeout(() => {
          if (this.isRegister) this.reloadUrl();
        }, startTime - this.currentTime);
      } else {
        Auction.getDetailAssetAuction(this.detail.TaiSanDauGia[0].Id);
      }
      if ((this.isAuctionStarted || this.isBiddingEnded) && !this.isAuctionEnded) {
        this.getHistory();
      }
    },
    async getDetailAuction() {
      const res = await Auction.getDetail(this.id);
      this.detail = res.data.Data;
    },
    dochangchuc(so, daydu) {
      var chuoi = '';
      let chuc = Math.floor(so / 10);
      let donvi = so % 10;
      if (chuc > 1) {
        chuoi = ' ' + mangso[chuc] + ' mươi';
        if (donvi === 1) {
          chuoi += ' mốt';
        }
      } else if (chuc === 1) {
        chuoi = ' mười';
        if (donvi === 1) {
          chuoi += ' một';
        }
      } else if (daydu && donvi > 0) {
        chuoi = ' lẻ';
      }
      if (donvi === 5 && chuc > 1) {
        chuoi += ' lăm';
      } else if (donvi > 1 || (donvi === 1 && chuc === 0)) {
        chuoi += ' ' + mangso[donvi];
      }
      return chuoi;
    },
    docblock(so, daydu) {
      var chuoi = '';
      let tram = Math.floor(so / 100);
      so = so % 100;
      if (daydu || tram > 0) {
        chuoi = ' ' + mangso[tram] + ' trăm';
        chuoi += this.dochangchuc(so, true);
      } else {
        chuoi = this.dochangchuc(so, false);
      }
      return chuoi;
    },
    dochangtrieu(so, daydu) {
      var chuoi = '';
      let trieu = Math.floor(so / 1000000);
      so = so % 1000000;
      if (trieu > 0) {
        chuoi = this.docblock(trieu, daydu) + ' triệu';
        daydu = true;
      }
      let nghin = Math.floor(so / 1000);
      so = so % 1000;
      if (nghin > 0) {
        chuoi += this.docblock(nghin, daydu) + ' nghìn';
        daydu = true;
      }
      if (so > 0) {
        chuoi += this.docblock(so, daydu);
      }
      return chuoi;
    },
    docso(so) {
      if (so === 0) return mangso[0];
      let chuoi = '';
      let hauto = '';
      do {
        let ty = so % 1000000000;
        so = Math.floor(so / 1000000000);
        if (so > 0) {
          chuoi = this.dochangtrieu(ty, true) + hauto + chuoi;
        } else {
          chuoi = this.dochangtrieu(ty, false) + hauto + chuoi;
        }
        hauto = ' tỷ';
      } while (so > 0);
      return chuoi;
    }
  }
};
</script>

<style scoped>
.spanauctionproperty {
  line-height: 1.7;
  font-size: 15px;
}
.span-red {
  font-size: 15px;
  color: #b41712 !important;
}

table,
th,
td {
  border: 1px solid #e6e6e6;
}
td,
th {
  padding: 10px 15px !important;
}
.row1::after {
  clear: initial !important;
}
.mouse-cover {
  width: 300px;
}
.amount {
  padding-bottom: 5px;
  color: #000000 !important;
  font-weight: 500;
}

table .is-noop:first-child {
  background-color: yellow;
}
.auction-time-countdown {
  font-weight: 600;
  text-transform: uppercase;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
  padding: 20px;
}
.countdown_section {
  display: block;
  float: left;
  font-size: 75%;
  text-align: center;
}
.countdown_show5 .countdown_section {
  width: 22.5%;
}
.countdown_amount {
  font-size: 200%;
}
.hasCountdown {
  overflow: hidden;
  padding: 0.7em 0;
}
.countdown_row {
  clear: both;
  width: 100%;
  padding: 0px 2px;
  text-align: center;
}

.primary-color {
  color: #fc3f00;
}

.row-active td,
.row-active span {
  color: #fc3f00 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ProductAuction.vue